// Deploy marker: re-announce staging QA tickets (cap 100, Slack block-split fix).
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import App from './app';
import './index.css';
import router from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    {/* <React.StrictMode> */}
    <App>
      <RouterProvider router={router} />
    </App>
    {/* </React.StrictMode> */}
  </>,
);
